import Map from './weatherMap';
import CommTabs from './commDevices/commTabs';
// import { RetailerSearch } from './aurora/retailerSearch';
import AuroraPage from './aurora/page'

export const utilities = translations => [
  {
    tab: translations.commDevices || 'Comm Devices',
    path: 'comm-devices',
    items: [
      {
        title: translations.device || 'Devices',
        description: translations.device || 'Devices',
        component: <CommTabs />,
      },
    ],
  },
  {
    tab: translations.aurora || 'Aurora',
    path: 'aurora',
    items: [
      {
        title: translations.aurora || 'Aurora',
        description: translations.aurora || 'Aurora',
        component: <AuroraPage />,
      },
    ],
  },
  {
    tab: translations.weatherMap || 'Weather Map',
    path: 'weather-map',
    items: [
      {
        title: translations.weatherMap || 'Weather Map',
        description: translations.weatherMap || 'Weather Map',
        component: <Map />,
      },
    ],
  },
];
